const pageLayouts = [ // TODO to be removed
  {
    path: '/page-layouts/collapsed-menu',
    name: 'page-layout-collapsed-menu',
    component: () => import('@hw-ui/ui/layouts/CollapsedMenu.vue'),
    meta: {
      pageTitle: 'Layout Collapsed Menu',
      breadcrumb: [
        {
          text: 'Layouts',
        },
        {
          text: 'Collapsed Menu',
          active: true,
        },
      ],
    },
  },
  {
    path: '/page-layouts/boxed-layout',
    name: 'page-layout-boxed-layout',
    component: () => import('@hw-ui/ui/layouts/BoxedLayout.vue'),
    meta: {
      pageTitle: 'Boxed Layout',
      breadcrumb: [
        {
          text: 'Layouts',
        },
        {
          text: 'Boxed Layout',
          active: true,
        },
      ],
    },
  },
  {
    path: '/page-layouts/without-menu',
    name: 'page-layout-without-menu',
    component: () => import('@hw-ui/ui/layouts/WithoutMenu.vue'),
    meta: {
      pageTitle: 'Layout Without Menu',
      breadcrumb: [
        {
          text: 'Layouts',
        },
        {
          text: 'Layout Without Menu',
          active: true,
        },
      ],
    },
  },
  {
    path: '/page-layouts/layout-empty',
    name: 'page-layout-layout-empty',
    component: () => import('@hw-ui/ui/layouts/LayoutEmpty.vue'),
    meta: {
      pageTitle: 'Layout Empty',
      breadcrumb: [
        {
          text: 'Layouts',
        },
        {
          text: 'Layout Empty',
          active: true,
        },
      ],
    },
  },
  {
    path: '/page-layouts/layout-blank',
    name: 'page-layout-layout-blank',
    component: () => import('@hw-ui/ui/layouts/LayoutBlank.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Layout Blank',
    },
  },
]

const colors = [
  {
    path: '/ui/colors',
    name: 'ui-colors',
    component: () => import('@hw-ui/styleguide/Colors.vue'),
    meta: {
      pageTitle: 'Colors',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Colors',
          active: true,
        },
      ],
    },
  },
]

const typography = [
  {
    path: '/ui/typography',
    name: 'ui-typography',
    component: () => import('@hw-ui/styleguide/typography/Typography.vue'),
    meta: {
      pageTitle: 'Typography',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Typography',
          active: true,
        },
      ],
    },
  },
]

const icons = [
  {
    path: '/ui/feather', // icon
    name: 'ui-feather',
    component: () => import('@hw-ui/styleguide/Feather.vue'),
    meta: {
      pageTitle: 'Feather',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Feather',
          active: true,
        },
      ],
    },
  },
]

export default [...colors, ...typography, ...icons, ...pageLayouts]
